// extracted by mini-css-extract-plugin
module.exports = {"dateData":"PromoCode_dateData__1wvzJ","qrButton":"PromoCode_qrButton__2lMpK"};